export default defineNuxtPlugin(() => {
  if (!import.meta.client) return;

  const { enabled, permission, loadPrefs, pollNewMatches, POLL_MS } = useReconNotifications();
  loadPrefs();

  let timer: ReturnType<typeof setInterval> | null = null;

  function startPoll() {
    stopPoll();
    if (!enabled.value || permission.value !== 'granted') return;
    void pollNewMatches();
    timer = setInterval(() => void pollNewMatches(), POLL_MS);
  }

  function stopPoll() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  watch([enabled, permission], startPoll, { immediate: true });

  window.addEventListener('recon-count', () => {
    if (enabled.value) void pollNewMatches();
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && enabled.value) void pollNewMatches();
  });
});
